import React from 'react';
import PropTypes from 'prop-types';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/component/geo';

import 'echarts/map/js/china.js';//全国地图
import 'echarts/map/js/province/anhui.js';//安徽
import 'echarts/map/js/province/aomen.js';//澳门
import 'echarts/map/js/province/beijing.js';//北京
import 'echarts/map/js/province/chongqing.js';//重庆
import 'echarts/map/js/province/fujian.js';//福建
import 'echarts/map/js/province/gansu.js';//甘肃
import 'echarts/map/js/province/guangdong.js';//广东
import 'echarts/map/js/province/guangxi.js';//广西
import 'echarts/map/js/province/guizhou.js';//贵州
import 'echarts/map/js/province/hainan.js';//海南
import 'echarts/map/js/province/hebei.js';//河北
import 'echarts/map/js/province/heilongjiang.js';//黑龙江
import 'echarts/map/js/province/henan.js';//河南
import 'echarts/map/js/province/hubei.js';//湖北
import 'echarts/map/js/province/hunan.js';//湖南
import 'echarts/map/js/province/jiangsu.js';//江苏
import 'echarts/map/js/province/jiangxi.js';//江西
import 'echarts/map/js/province/jilin.js';//吉林
import 'echarts/map/js/province/liaoning.js';//辽宁
import 'echarts/map/js/province/neimenggu.js';//内蒙古
import 'echarts/map/js/province/ningxia.js';//宁夏
import 'echarts/map/js/province/qinghai.js';//青海
import 'echarts/map/js/province/shandong.js';//山东
import 'echarts/map/js/province/shanghai.js';//上海
import 'echarts/map/js/province/shanxi.js';//山西
import 'echarts/map/js/province/shanxi1.js';//陕西
import 'echarts/map/js/province/sichuan.js';//四川
import 'echarts/map/js/province/taiwan.js';//台湾
import 'echarts/map/js/province/tianjin.js';//天津
import 'echarts/map/js/province/xianggang.js';//香港
import 'echarts/map/js/province/xinjiang.js';//新疆
import 'echarts/map/js/province/xizang.js';//西藏
import 'echarts/map/js/province/yunnan.js';//云南
import 'echarts/map/js/province/zhejiang.js';//浙江


import { geoCoordMap, mapStyleData } from './data.js';
import NHFetch from '../../utils/NHFetch.js';

const yxxtBasicUrl = 'api/zhxg-yxxt'; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 10 * 1000; //轮询时间间隔


/**
 * * 动态地图展示面板
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-07-05
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            errCount: 0, //连续请求错误次数
            mapData: [], //生源地招生人数数据
        }

        this.polling; //轮询定时器
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        //组件卸载时清除轮询定时器
        if (this.polling) {
            clearTimeout(this.polling);
        }
    }

    /**
     * * 获取生源地招生人数数据
     * @memberof IndexComponent
     */
    getData = () => {
        NHFetch(yxxtBasicUrl + '/sstj/getStatisticsForSourceAreaStudentsByLcid', 'GET',{pkid: this.props.pkid})
            .then(res => {
                if (res && res.data) {
                    this.setState({ errCount: 0, mapData: res.data });
                }
            }).catch(err => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: errCount + 1 });
                } else {
                    //异常超过3次后终止轮询
                    if (this.polling) {
                        clearTimeout(this.polling);
                    }
                }
            });
    }

    getGeoOption = () => {
        const { mapData = [] } = this.state;
        const { rem, schoolLocation = '', mapProvince = '' } = this.props;

        let option = null;

        //生源地总人数
        let zsrs = 0;
        //生源地平均人数
        let avg = 0;

        //生源地散点最大值
        const symbolMaxSize = 20;

        const geoData = [];
        mapData.map(item => {
            zsrs += item.zsrs;
            if(geoCoordMap[item.syd]){
                geoData.push([{ name: item.syd, value: item.zsrs }, { name: schoolLocation }]);
            }
        });

        if (mapData.length > 0) {

            avg = parseInt(zsrs / mapData.length); //生源地平均人数
        }

        //连线特效矢量图
        const planePath =
            'path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z';
        const convertData = function (data) {
            const res = [];
            for (let i = 0; i < data.length; i++) {
                const dataItem = data[i];
                const fromCoord = geoCoordMap[dataItem[0].name];
                const toCoord = geoCoordMap[dataItem[1].name];
                if (fromCoord && toCoord) {
                    res.push({
                        fromName: dataItem[0].name,
                        toName: dataItem[1].name,
                        coords: [fromCoord, toCoord]
                    });
                }
            }
            return res;
        };

        //连接线颜色值
        const color = ['#ffff00'];

        const series = [];

        if (geoData.length > 0) {

            [[geoData]].forEach(function (item, i) {
                series.push(
                    {
                        //来源源——目标点连线
                        name: '全国生源地分布图',
                        type: 'lines',
                        zlevel: 1,
                        effect: {
                            show: true,
                            period: 6,
                            trailLength: 0.7,
                            color: '#fff',
                            symbolSize: 3
                        },
                        lineStyle: {
                            normal: {
                                color: color[i],
                                width: 0,
                                opacity: 0.6,
                                curveness: 0.2
                            }
                        },
                        data: convertData(item[0])
                    },
                    {
                        //来源源——目标点连线特效（动态矢量图）
                        name: '全国生源地分布图',
                        type: 'lines',
                        zlevel: 2,
                        symbol: ['none', 'arrow'],
                        symbolSize: 10,
                        effect: {
                            show: false,
                            period: 6,
                            trailLength: 0,
                            symbol: planePath,
                            symbolSize: 15
                        },
                        lineStyle: {
                            normal: {
                                color: color[i],
                                width: 1,
                                curveness: 0.2
                            }
                        },
                        markPoint: {
                            symbol: 'pin',
                            symbolSize: 10,
                            label: {
                                normal: {
                                    show: true,
                                    color: '#fff',
                                    position: 'top',
                                    formatter: function (d) {
                                        return d.name;
                                    }
                                }
                            },
                            data: [{ name: '钓鱼岛', coord: [123.4764, 25.7446] }]
                        },
                        data: convertData(item[0])
                    },
                    {
                        //带有涟漪特效动画的散点，这里表示来源点
                        name: '全国生源地分布图',
                        type: 'effectScatter',
                        coordinateSystem: 'geo', //使用地理坐标系
                        zlevel: 2,
                        rippleEffect: {
                            brushType: 'stroke' //涟漪点波纹特效
                        },
                        label: {
                            normal: {
                                show: true,
                                position: 'right',
                                formatter: '{b}'
                            }
                        },
                        symbolSize: function (val) {//坐标点大小
                            //val:[116.4, 39.9, 100]经度、纬度、值，这里的值是生源地学生数量
                            if (avg == 0) {
                                return symbolMaxSize / 2;
                            } else if (avg > 0 && avg < 10) {
                                return val[2] * 2 <= symbolMaxSize ? val[2] * 2 : symbolMaxSize;
                            } else if (avg >= 10 && avg < 100) {
                                return val[2] * 0.2 <= symbolMaxSize ? val[2] * 0.2 : symbolMaxSize;
                            } else if (avg >= 100 && avg < 1000) {
                                return val[2] * 0.1 <= symbolMaxSize ? val[2] * 0.1 : symbolMaxSize;
                            } else {
                                return val[2] * 0.01 <= symbolMaxSize ? val[2] * 0.01 : symbolMaxSize;
                            }

                        },
                        itemStyle: {
                            normal: {
                                show: true,
                                color: '#fff'
                            }
                        },
                        data: item[0].map(function (dataItem) {
                            return {
                                name: dataItem[0].name,
                                value: geoCoordMap[dataItem[0].name].concat([dataItem[0].value])
                            };
                        })
                    }
                );
            });
        }


        //根据系统参数设置地图的样式

        let optionData = {};

        if (mapProvince != '') {
            for (let p in mapStyleData) {
                if (mapProvince.indexOf(p) >= 0) {
                    optionData['titleText'] = mapProvince + '生源地分布图';
                    optionData['geoName'] = p;
                    optionData['geoStyle'] = mapStyleData[p];
                    break;
                }
            }
            if (Object.keys(optionData).length == 0) {
                optionData['titleText'] = '全国生源地分布图';
                optionData['geoName'] = 'china';
                optionData['geoStyle'] = mapStyleData['全国'];
            }
        } else {
            optionData['titleText'] = '全国生源地分布图';
            optionData['geoName'] = 'china';
            optionData['geoStyle'] = mapStyleData['全国'];
        }


        option = {
            backgroundColor: 'transparent',
            title: {
                text: optionData.titleText,
                left: 'center',
                textStyle: {
                    color: '#fff'
                }
            },
            tooltip: {
                trigger: 'item',
                formatter: (params) => {
                    const { seriesName, seriesType, name, value } = params;
                    if (seriesType == 'effectScatter') {
                        return `${seriesName}<br/>${name}：${value[2]}人`;
                    }
                }
            },
            geo: {
                map: optionData.geoName,
                top: optionData.geoStyle.top,
                right: optionData.geoStyle.right,
                bottom: optionData.geoStyle.bottom,
                left: optionData.geoStyle.left,
                label: {
                    position: ['50%', '50%'],
                    normal: {
                        show: false,
                        textStyle: {
                            color: '#fff',
                            fontSize: 0.12 * rem
                        }
                    },
                    emphasis: {
                        show: false,
                        textStyle: {
                            color: '#fff',
                            fontSize: 0.12 * rem
                        }
                    }
                },
                itemStyle: {
                    normal: {
                        show: true,
                        shadowColor: 'rgba(0, 0, 0, 0.5)',
                        areaColor: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                                {
                                    offset: 0,
                                    color: '#3398e6' // 0% 处的颜色
                                },
                                {
                                    offset: 1,
                                    color: '#4cf2ce' // 100% 处的颜色
                                }
                            ],
                            globalCoord: false // 缺省为 false
                        },
                        borderColor: '#fff'
                    },
                    emphasis: {
                        areaColor: '#245eb2'
                    },
                    regions: [
                        {
                            name: '南海诸岛',
                            itemStyle: {
                                areaColor: 'red',
                                color: 'red'
                            }
                        }
                    ]
                }
            },
            series: series
        };
        return option;
    };

    render() {
        return (
            <ReactEchartsCore
                style={{ width: '100%', height: '100%' }}
                echarts={echarts}
                option={this.getGeoOption()}
                notMerge={true}
                lazyUpdate={true}
            />
        )
    }

}

IndexComponent.defaultProps = {
}

IndexComponent.propTypes = {
    rem: PropTypes.number,
    schoolLocation: PropTypes.string, //学校所在地行政区划
    mapProvince: PropTypes.string, //地图省份
}

export default IndexComponent;


// WEBPACK FOOTER //
// ./containers/Show/_Map.js